<template>
  <div id="offers">
    <header-o :model="headerData"></header-o>
    <div class="margin-vertical-10 offer-card" style="margin-top: -180px">
      <div class="bg-light bottom-radius-5 padding-horizontal-15 pos-rel box-shadow" :class="[isInviteEarn ? 'margin-bottom-90' : 'margin-bottom-10']" :style="{minHeight: isInviteEarn ? '80vh' : '60vh'}" v-if="!isEmpty(offerData)">
        <div class="margin-bottom-10">
          <img class="medium-icon margin-bottom-5" src="@/assets/check-in.svg" v-if="isCheckIn">
          <img class="medium-icon margin-bottom-5" src="@/assets/invite.svg" v-else-if="isInviteEarn">
          <img class="medium-icon margin-bottom-5" src="@/assets/game-zone.svg" v-else-if="isGameZone">
          <div class="margin-bottom-20 font-bold text-semi-large padding-vertical-20">{{stripHTML(offerData.title)}}</div>
          <div class="margin-bottom-20 padding-vertical-20 word-break" v-html="offerData.description"></div>
          <img class="w85" :src="offerData.image_url" v-if="isCheckIn && offerData.image_url && !offerData.image_url.includes('default_checkin_offer.png')">
          <img class="w50" :src="offerData.image_url" v-else-if="isCheckIn">
          <img class="w85" :src="offerData.image_url" v-if="offerData.offer_type_title.includes('Challenges')"/>
          <div class="text-left text-small" style="padding: 0 0 0 16px" v-if="offerData.offer_type_title.includes('Challenges')">{{offerData.time_text}}</div>
          <!-- <img class="w50" src="@/assets/retention-banner.svg" v-else-if="isCheckIn"> -->
          <milestone v-if="isCheckIn" :model="offerData"></milestone>
          <div class="invite-earn-content margin-bottom-30 pos-rel" v-if="(isGamification || isInviteEarn)">
            <div class="text-large font-bold margin-bottom-10" v-if="(isInviteEarn && !isGamification)">Events</div>
            <div class="text-large font-bold margin-bottom-10" v-else-if="isInviteEarn && isGamification">Badge Level</div>
            <table class="full-width invite-earn margin-bottom-10 padding-vertical-10" v-if="(isInviteEarn && !isGamification)" CELLSPACING=0>
              <thead class="font-bold bottom-border">
              <tr>
                <th class="padding-horizontal-10 bottom-border">
                  <div class="align-hor center-ver center-hor"><img class="smaller-icon margin-right-5" src="@/assets/target.svg"> <span>Tasks</span></div>
                </th>
                <th class="padding-horizontal-10 bottom-border">
                  <div class="align-hor center-ver center-hor"><img class="smaller-icon margin-right-5" src="@/assets/man.svg"> <span>You Win</span></div>
                </th>
                <th class="padding-horizontal-10 bottom-border" v-if="hasReferee">
                  <div class="align-hor center-ver center-hor"><img class="smaller-icon margin-right-5" src="@/assets/team.svg"> <span>Friend Wins</span></div>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="oe in offerData.offer_events" class="bottom-border" style="border-bottom: 1px solid red">
                <td class="bottom-border padding-horizontal-15">{{oe.name}}</td>
                <td class="bottom-border padding-horizontal-15">
                  <div v-if="(oe.min_reward_referrer > 0 && oe.max_reward_referrer > 0) || (oe.max_reward_referrer > 0)">
                    <div class="margin-bottom-5">
                      <img class="extra-small-icon margin-right-5" :src="offerData.currency_icon_url">
                      <span>{{offerData.currency_label}}</span>
                    </div>
                    <button class="radius-3 bg-light no-outline padding-0510" :style="{border: '1px solid ' + bgTheme}" v-if="(oe.min_reward_referrer == 0 && oe.max_reward_referrer > 0)">Upto {{formatReward(offerData.currency_label, oe.max_reward_referrer, false)}}</button>
                    <button class="radius-3 bg-light no-outline padding-0510" :style="{border: '1px solid ' + bgTheme}" v-else>{{formatReward(offerData.currency_label, oe.min_reward_referrer, false)}} to {{formatReward(offerData.currency_label, oe.max_reward_referrer, false)}}</button>
                  </div>
                  <button class="radius-3 bg-light no-outline border-none" v-else>--</button>
                </td>
                <td class="bottom-border padding-horizontal-15" v-if="hasReferee">
                  <div v-if="(oe.min_reward_referee > 0 && oe.max_reward_referee > 0) || (oe.max_reward_referee > 0)">
                    <div class="margin-bottom-5">
                      <img class="extra-small-icon margin-right-5" :src="offerData.currency_icon_url">
                      <span>{{offerData.currency_label}}</span>
                    </div>
                    <button class="radius-3 bg-light no-outline padding-0510" :style="{border: '1px solid ' + bgTheme}" v-if="(oe.min_reward_referee == 0 && oe.max_reward_referee > 0)">Upto {{formatReward(offerData.currency_label, oe.max_reward_referee, false)}}</button>
                    <button class="radius-3 bg-light no-outline padding-0510" :style="{border: '1px solid ' + bgTheme}" v-else>{{formatReward(offerData.currency_label, oe.min_reward_referee, false)}} to {{formatReward(offerData.currency_label, oe.max_reward_referee, false)}}</button>
                  </div>
                  <button class="radius-3 bg-light no-outline border-none" v-else>--</button>
                </td>
              </tr>
              </tbody>
            </table>

            <div class="padding-vertical-10 invite-earn-with-gamification margin-bottom-10" v-if="isGamification">
              <div v-for="prize in offerData.offer_prizes" class="align-hor center-ver space-between margin-bottom-10 padding-bottom-10 bottom-border">
                <div class="align-hor center-ver">
                  <div class="margin-right-10">
                    <img class="medium-icon" v-if="prize.badge_url" :src="prize.badge_url">
                    <img class="medium-icon" v-else src="@/assets/medal.svg">
                  </div>
                  <div class="text-left">
                    <div class="font-bold text-regular margin-bottom-5">{{prize.label}}</div>
                    <div>For Referral {{prize.min_ref}} to {{prize.max_ref}}</div>
                  </div>
                </div>
                <div>
                  <div class="margin-bottom-5">
                    <img class="extra-small-icon margin-right-5" :src="offerData.currency_icon_url">
                    <span>{{offerData.currency_label}}</span>
                  </div>
                  <button class="radius-3 bg-light no-outline padding-5" :style="{border: '1px solid ' + bgTheme}">{{formatReward(offerData.currency_label, prize.min_win, false)}} to {{formatReward(offerData.currency_label, prize.max_win, false)}}</button>
                </div>
              </div>
            </div>
            <div class="text-smaller pull-right padding-vertical-10" v-if="isInviteEarn">Campaign ends on {{formattedDate(offerData.ends_at, false)}}</div>
          </div>
          <div v-if="isCheckIn && !offerData.event_id">
            <button class="custom-button small text-light padding-10 radius-5 margin-bottom-30 text-large pointer text-uppercase" :style="{background: bgTheme}" v-if="offerData.checked_in" >Checked in</button>
            <button class="custom-button small text-light padding-10 radius-5 margin-bottom-30 text-large pointer text-uppercase" :style="{background: bgTheme}" @click.stop.prevent="dailyCheckin(offerData)" v-else>Check in</button>
          </div>
          <div class="offer-details padding-vertical-20">
            <div class="text-large font-bold margin-bottom-20">Offer Details</div>
            <div class="text-left word-break" v-if="offerTerms.length>0">
              <div class="margin-bottom-10" v-for="term in offerTerms" v-html="term"></div>
            </div>
            <div v-else class="text-left word-break">
              <div class="margin-bottom-10" v-html="offerData.details"></div>
            </div>
          </div>
        </div>

        <div class="top-border-light-grey padding-horizontal-10 pos-fixed pos-center-hor pull-down bg-light" v-if="isInviteEarn || isGamification">
          <div class="font-bold text-large margin-bottom-10 text-uppercase">Invite now</div>
          <div class="share align-hor center-ver center-hor">
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'wa')">
              <img class="medium-icon margin-right-5" src="@/assets/share/whatsup.png">
            </div>
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'fb')">
              <img class="medium-icon margin-right-5" src="@/assets/share/fb.png">
            </div>
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'tw')">
              <img class="medium-icon margin-right-5" src="@/assets/share/tiw.png">
            </div>
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'gm')">
              <img class="medium-icon margin-right-5" src="@/assets/share/gmail.png">
            </div>
            <div class="share-action-button show-in-mobile pointer" @click="getShareMsg(offerData.id, 'cp')">
              <img class="medium-icon margin-right-5" src="@/assets/share/copy.png">
            </div>
          </div>
        </div>
        <div id="copied-toast" class="font-bold pos-fixed pos-center-hor pull-down" style="width: 100px; padding: 5px; border-radius: 10px; background: rgba(0, 0, 0, 0.3); margin-bottom: 70px; color: white; display: none;">
          Link Copied
        </div>
      </div>

      <div v-if="isEmpty(offerData)">
        <div class="bg-light radius-5 padding-20 margin-bottom-10 pos-rel">
          <div class="wrapper align-ver center-ver margin-bottom-5">
            <div class="comment animate bg-light-grey w10"></div>
            <div class="comment animate bg-light-grey margin-bottom-10 w10"></div>
          </div>
          <div class="padding-vertical-20 margin-bottom-10">
            <div class="wrapper margin-bottom-20">
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey w85"></div>
            </div>
            <div class="wrapper margin-bottom-20">
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey"></div>
            </div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-20">
            <div class="comment animate bg-light-grey w20"></div>
            <div class="comment animate bg-light-grey w20"></div>
          </div>
          <div class="padding-vertical-20 margin-bottom-20">
            <div class="align-hor center-ver space-between bottom-border padding-bottom-10">
              <div class="w20" v-for="$i in 3">
                <div class="wrapper align-hor center-hor">
                  <div class="comment animate bg-light-grey margin-bottom-5 w20 margin-right-5"></div>
                  <div class="comment animate bg-light-grey margin-bottom-5 w80"></div>
                </div>
              </div>
            </div>
            <div class="wrapper align-hor center-ver space-between bottom-border padding-horizontal-20" v-for="$i in 3">
              <div class="comment animate bg-light-grey w20"></div>
              <div class="comment animate bg-light-grey w20"></div>
              <div class="comment animate bg-light-grey w20"></div>
            </div>
          </div>
          <div class="wrapper align-ver center-ver margin-bottom-20">
            <div class="comment animate bg-light-grey w20"></div>
            <div class="comment animate bg-light-grey w20"></div>
          </div>
          <div class="padding-vertical-20 margin-bottom-10" v-for="$1 in 2">
            <div class="wrapper margin-bottom-20">
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey w85"></div>
            </div>
            <div class="wrapper margin-bottom-20">
              <div class="comment animate bg-light-grey margin-bottom-10 w80"></div>
              <div class="comment animate bg-light-grey"></div>
            </div>
          </div>
        </div>
      </div>

      <Drawer  :maskClosable="true"
               :zIndex="1002"
               @close="toggle()"
               :closeable="true"
               :header-text="'Terms & Conditions'">
        <div v-if="open">
          <div v-html="offerData.tnc"></div>
          <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 5px">
            <button @click="acceptTnc" class="accept-btn">Accept</button>
          </div>
        </div>

      </Drawer>
    </div>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals"
import axios from "axios"
import OverlapHeader from '@/components/overlapped-header'
import Milestone from '@/components/milestone'
import Drawer from "@/components/drawer"

export default {
  mixins: [globals],
  components: {
    'header-o': OverlapHeader,
    'milestone': Milestone,
    Drawer
  },
  data() {
    return {
      headerData: {
        onlyHeader: true
      },
      is_checkin: false,
      is_invite_earn: false,
      is_game_zone: false,
      offerData: {},
      offerTerms: [],
      hasReferee: false,
      open: false
    }
  },
  computed: {
    isInviteEarn: function() {
      return this.is_invite_earn;
    },
    isCheckIn: function() {
      return this.is_checkin;
    },
    isGameZone: function() {
      return this.is_game_zone;
    }
  },
  methods: {
    getOfferDetails(id) {
      var self = this;
      var url = this.$store.getters.flyyDomain + '/v1/get_offer/'+id;
      var headers = this.$store.getters.headers;
      axios.get(url, {
        mode: 'no-cors',
        headers: headers,
        params: {
          page: this.page,
        }
      }).then((resp) => {
        if(resp.data.success) {
          var offer = resp.data.offer;
          this.offerData = offer;
          var type = offer.offer_type_code;
          this.open = offer.show_tnc && !offer.tnc_accepted;
          if(type.includes("checkin")) {
            this.is_checkin = true;
            this.is_game_zone = false;
            this.is_invite_earn = false;
            this.$store.state.user.milestones = offer.milestones;
          }
          else if(type.includes("invite") || type.includes("gamification")) {
            this.is_checkin = false;
            this.is_game_zone = false;
            this.is_invite_earn = true;
            if(type.includes("gamification")) {
              this.$store.state.hasGamification = true;
            } else {
              this.$store.state.hasGamification = false;
            }
          }
          else if(type.includes("game")) {
            this.is_checkin = false;
            this.is_game_zone = true;
            this.is_invite_earn = false;
          }

          if(offer.offer_events && offer.offer_events.length > 0) {
            var has_referee = offer.offer_events.filter((oe) => {return oe.reward_referee === true})
            this.hasReferee = (has_referee.length > 0) ? true : false;
          }

          this.offerTerms = this.formatOfferTerms(offer.offer_terms)
          if(type.includes("invite")) {
            this.$store.state.headTitle = "Invite & Earn";
          } else if(type.includes("checkin")) {
            this.$store.state.headTitle = "Daily Checkin";
          } else {
            this.$store.state.headTitle = this.formatOfferTitle(type);
          }
          this.$store.state.showHeader = false;
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    toggle() {
      this.back();
    },
    closeAndAccept() {
      this.open = !this.open;
    },
    acceptTnc() {
      var url = this.$store.getters.flyyDomain + '/accept_tnc/'+this.offerData.id;
      var headers = this.$store.getters.headers;
      axios.get(url, {
        mode: 'no-cors',
        headers: headers,
      }).then((resp) => {
        if(resp.data) {
          this.open = resp.data.success;
          this.closeAndAccept();
        }
      });
    }
  },
  created() {
    if(!this.isEmpty(this.$route.params)) {
      this.getOfferDetails(this.$route.params.id);
    }
  }
}
</script>
<style>
.currency-type {
  position: absolute;
  top: 10px;
  right: 10px;
}
.milestone-wrapper {
  overflow-y: visible;
  white-space: nowrap;
  background: #ffffff;
  left: 0;
  right: 0;
//padding-left: 50px;
  margin: 15px 0px;
}
.check-mark {
  display: inline-block;
  transform: rotate(45deg);
  width: 5px;
  height: 13px;
  border-bottom: 2px solid #ffffff;
  border-right: 2px solid #ffffff;
}
.padding-bottom-60 {
  padding-bottom: 60px;
}
.invite-earn tr td {
  width: 90px;
}
.invite-earn tr td:first-child {
  width: 50px;
}
.accept-btn {
  padding: 5px 23px;
  border-radius: 7px;
  color: #FFFFFF;
  font-size: 16px;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  background: var(--bg-color);
}
</style>



// WEBPACK FOOTER //
// src/screens/stamp-campaign.vue